import createBoardsSaga from './createBoardSaga';
import { selectors, actions } from './matCoordsSlice';
import { MAT_COORDS_NAME } from './matConfigs';

function* watchMatCoordsChanges() {
    yield createBoardsSaga({
        selectors,
        actions,
        boardName: MAT_COORDS_NAME,
    });
}

export default watchMatCoordsChanges;
